'use client'

import { Flex } from 'antd'

import { Empty } from 'shared/ui/empty'
import { EmptyStateType } from 'shared/ui/empty/types'

export default function NotFound() {
  return (
    <Flex justify="center" align="center" style={{ height: '100dvh' }}>
      <Empty variant={EmptyStateType.NOT_FOUND} />
    </Flex>
  )
}
